import React from "react";
import {PieChart} from "react-chartkick";
import "chart.js";
import CardHolder from "./CardHolder";

interface CardHeaderProps {
    data: any[];
}
const CardHeader = (props: CardHeaderProps) => {
    const {data} = props;
    return (
        <>
            {data.map(({color, name}, index) => {
                return (
                    <div
                        key={index}
                        className="legenda"
                        style={{
                            backgroundColor: color,
                        }}
                    >
                        {name}
                    </div>
                );
            })}
        </>
    );
};

const chartOptionsDonut = {
    elements: {
        arc: {
            borderWidth: 0,
            borderColor: "#fff",
        },
    },

    layout: {
        padding: {
            left: 40,
            right: 40,
            top: 20,
            bottom: 20,
        },
    },
    cutoutPercentage: 80,
    animation: {
        animateScale: true,
    },
};

const chartOptionsPie = {
    elements: {
        arc: {
            borderWidth: 0,
            borderColor: "#fff",
        },
    },

    layout: {
        padding: {
            left: 0,
            right: 240,
            top: 20,
            bottom: 20,
        },
    },
    cutoutPercentage: 0,
    animation: {
        animateScale: true,
    },
};

interface PieChartCardProps {
    title: string;
    data: any[];
    donut?: [];
    suffix?: string;
    legend: string | boolean;
    discrete?: boolean;
    center?: string;
    colors?: any;
    stacked?: boolean;
}

const PieChartCard = (props: PieChartCardProps) => {
    const {length, map} = props.data;
    return (
        <CardHolder title={props.title}>
            {length === 2 && (
                <div className="absolute inset-0 flex flex-col lg:flex-row z-20 bg-transparent justify-evenly items-center py-16 px-4">
                    <span
                        className="mt-4 w-32 flex flex-col capitalize text-xl"
                        style={{
                            color: props.colors ? props.colors : [0],
                        }}
                    >
                        {props.data[0].map((item, index) => (
                            <span key={index}>{item}</span>
                        ))}
                    </span>
                    <span className="mt-4 w-32 flex-grow flex justify-center items-center">
                        <span className="w-32 mx-auto text-2xl block break-words">{props.center}</span>
                    </span>
                    <span
                        className="mt-4 w-32 flex flex-col capitalize text-xl"
                        style={{
                            color: props.colors ? props.colors : [1],
                        }}
                    >
                        {props.data[1].map((item, index) => (
                            <span key={index}>{item}</span>
                        ))}
                    </span>
                </div>
            )}

            {length > 2 && (
                <div className="absolute inset-y-0 right-0 flex flex-row z-20 bg-transparent justify-evenly items-center p-4">
                    <span className="mt-4 w-52 flex flex-col capitalize text-lg">
                        {map((item, index) => (
                            <span key={index} className={"flex flex-row items-center"}>
                                <span className="w-2 h-2 rounded-full mr-2" style={{backgroundColor: props.colors[index]}}></span>
                                <div className="LegendItem">{item[0]}</div>
                            </span>
                        ))}
                    </span>
                </div>
            )}
            <CardHeader data={props.data} />
            <PieChart
                colors={props.colors || []}
                data={props.data}
                discrete={props.discrete || false}
                donut={props.donut || true}
                legend={props.legend || false}
                library={length > 2 ? chartOptionsPie : chartOptionsDonut}
                stacked={props.stacked || false}
                suffix={props.suffix || false}
            />
        </CardHolder>
    );
};
export default PieChartCard;
